import { Component, input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-section-error",
  imports: [MatIconModule],
  templateUrl: "./section-error.component.html",
  styleUrl: "./section-error.component.scss",
})
export class SectionErrorComponent {
  readonly refreshLink = input<string>("/");
  readonly message = input<string>("");
}
